import LocalizedLink from './localized_link';

export default LocalizedLink;
